import React from "react";
import { FaStar } from "react-icons/fa";

const TestimonialsComponent = () => {
    const testimonials = [
        {
            name: "Mrs. Olayemi",
            class: "Parent",
            text: "TeeChaa gave me clear visibility into my child’s progress. I could track strengths and weaknesses easily, and it gave me peace of mind seeing steady improvement.",
            rating: 5
        },
        {
            name: "Ibrahim M.",
            class: "JSS2 Student",
            text: "The interactive quizzes make learning fun. I've improved in Math significantly!",
            rating: 5
        },
        {
            name: "Blessing C.",
            class: "SS1 Student",
            text: "Best study app for Nigerian students. The explanations are so clear!",
            rating: 5
        }
    ];

    return (
         <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-6">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-gray-800 mb-4">What Students and Parents Say</h2>
                        <p className="text-xl text-gray-600">Real feedback from students using TeeChaa</p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                        {testimonials.map((testimonial, index) => (
                            <div key={index} className="bg-white p-6 rounded-2xl shadow-lg">
                                <div className="flex mb-4">
                                    {[...Array(testimonial.rating)].map((_, i) => (
                                        <FaStar key={i} className="text-yellow-400" />
                                    ))}
                                </div>
                                <p className="text-gray-600 mb-4 italic">"{testimonial.text}"</p>
                                <div>
                                    <p className="font-semibold text-gray-800">{testimonial.name}</p>
                                    <p className="text-sm text-gray-500">{testimonial.class}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
    );
};

export default TestimonialsComponent;
